export default __webpack_public_path__ + "31456d650de1073275dfc4436417ee14.svg";